'use client';
import React, { useRef, useEffect, useState } from 'react';

function IframePlayer({ video }) {
  const containerRef = useRef(null);
  const [height, setHeight] = useState(200); // Default height

  useEffect(() => {
    const calculateHeight = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;

        const aspectRatioFactor = 9 / 16; // For a 16:9 aspect ratio
        const calculatedHeight = containerWidth * aspectRatioFactor;

        // Set the calculated height
        setHeight(calculatedHeight);
      }
    };

    // Calculate the height initially and listen for window resize
    calculateHeight();
    window.addEventListener('resize', calculateHeight);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('resize', calculateHeight);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`p-2 rounded-md border-2 border-light-gray-200 hover:border-color-primary transition-all duration-200 bg-white`}
    >
      {/* Video preview */}
      <video
        controls
        style={{ width: '100%', height: `${height}px` }}
        src={video?.url}
      />
      <div className="mt-4 text-sm text-center">{video.name}</div>
    </div>
  );
}

export default IframePlayer;
